import React, { useRef, useEffect, useState } from 'react';
import clsx from "clsx";
import customStyles from "../../../../assets/styles/customStyles";
import { Image, Dropdown, Menu, Row, Col } from "antd";
import { NavLink } from "react-router-dom";
import hamburgerMenu from "../../../../assets/images/icon_actions/hamburgerMenu.svg";
import lastMonth from "../../../../assets/images/lastMonth.png";
import currentMonth from "../../../../assets/images/currentMonth.png";
import lastMonthReverse from "../../../../assets/images/lastMonthReverse.png";
import currentMonthReverse from "../../../../assets/images/currentMonthReverse.png";
import { downloadImageCommon, exportChatFile, currencyFormatInt } from "../../../../helpers/utilities";
import { Tooltip, IconButton } from "@mui/material";
import infoMarkIcon from "../../../../assets/images/icon_actions/infoMark.svg";


export const MonthlySales = (props) => {
    const { title, monthPercent, currentMonthTotal, lastMonthTotal, percent_type, sTitle, toolTip } = props;
    const monthlySales = useRef(null);
    const classes = customStyles();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
    }, []);

    const handleImageDownload = (type) => {
        if (type === 'csv') {
            exportFile();
        } else {
            downloadImageCommon(monthlySales.current, title, type);
        }
    }

    const exportFile = () => {
        let newHead = [
            ['Last Month', 'Current Month', 'Percentage'],
            [lastMonthTotal, currentMonthTotal, monthPercent.toFixed(2)]
        ];
        exportChatFile(title, newHead);
    }

    //let width = swiper !== '' ? document.querySelectorAll(`#swiper-admin-details .swiper-pagination`)[0].offsetWidth : 0;
    return (
        <div ref={monthlySales}>
            <div className={clsx(classes.monthlyDiv, { [classes.monthlySalesLoading]: loading })}>
                <div className={clsx(classes.monthlyDivTitle, classes.bold)}>
                    {`${title}`}
                    <Tooltip
                        classes={{ popper: classes.customToolTip }}
                        title={toolTip}
                        arrow placement="top" className={clsx(classes.tooltip, classes.typographyHeaderToolTipCustom)}>
                        <IconButton>
                            <Image src={infoMarkIcon} preview={false} />
                        </IconButton>
                    </Tooltip>
                    <span className={classes.hamburgerMenu}>
                        <Dropdown
                            placement="bottomLeft"
                            trigger={['click']}
                            overlay={
                                <Menu className={clsx(classes.groupMenu, classes.hamburgeGroupMenu)}>
                                    <Menu.Item key={"Download PNG"}><NavLink to={'#'} onClick={() => handleImageDownload('png')}>Download PNG</NavLink></Menu.Item>
                                    <Menu.Item key={"Download CSV"}><NavLink to={'#'} onClick={() => handleImageDownload('csv')}>Download CSV</NavLink></Menu.Item>
                                </Menu>
                            }>
                            <Image src={hamburgerMenu} preview={false} />
                        </Dropdown>
                    </span>
                </div>
                <div className={classes.monthlyDivTitleNext}>
                    {
                        percent_type === 'Decreases' ? <div className={classes.monthlySalesDecreases}>
                            <div className={classes.lastMonth}>
                                <div className={clsx(classes.triAngleContent, classes.triAngleContentImage, classes.deLastTriAngleContentImage)}>
                                    <div className={classes.bgFull} style={{ backgroundImage: `url(${lastMonthReverse})` }}></div>
                                </div>
                                <div className={clsx(classes.triAngleContent, classes.triAngleContentAnimation)}>
                                    <div className={clsx(classes.triAngleContentText, classes.bold)}>{`Last Month ${sTitle} Total`}</div>
                                    <div className={clsx(classes.triAngleContentAmount, classes.bold)}>₹ {currencyFormatInt(lastMonthTotal)}</div>
                                </div>
                            </div>
                            <div className={clsx(classes.currentMonth, classes.lastMonthBorder)}>
                                <div className={classes.currentMonthIncreases}>
                                    <Row style={{ alignItems: "start" }}>
                                        <Col span={10}>
                                            <div className={classes.percentageAnimation}>
                                                <div className={clsx(classes.currentMonthPer, classes.bold)}>{percent_type !== 'zero' ? `${parseInt(monthPercent)} %` : `0 %`}</div>
                                                {
                                                    percent_type !== 'zero' ? <div className={clsx(classes.currentMonthText, classes.bold, percent_type)}>{'Decrease'}</div> : <div className={clsx(classes.currentMonthText, classes.bold, percent_type)}>{''}</div>
                                                }
                                            </div>
                                        </Col>
                                        <Col span={14}>
                                            <div className={clsx(classes.triAngleContent, classes.triAngleContentImage, classes.deCurrentTriAngleContentImage)}>
                                                <div className={classes.bgFull} style={{ backgroundImage: `url(${currentMonthReverse})` }}></div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                                <div className={clsx(classes.triAngleContent, classes.triAngleContentAnimation)}>
                                    <div className={clsx(classes.triAngleContentAmount, classes.bold)}>₹ {currencyFormatInt(currentMonthTotal)}</div>
                                    <div className={clsx(classes.triAngleContentText, classes.bold)}>{`Current Month ${sTitle} Total`}</div>
                                </div>
                            </div>
                        </div> : <>
                            <div className={classes.currentMonth}>
                                <div className={classes.currentMonthIncreases}>
                                    <Row style={{ alignItems: "end" }}>
                                        <Col span={10}>
                                            <div className={classes.percentageAnimation}>
                                                <div className={clsx(classes.currentMonthPer, classes.bold)}>{percent_type !== 'zero' ? `${parseInt(monthPercent)} %` : `0 %`}</div>
                                                {
                                                    percent_type !== 'zero' ? <div className={clsx(classes.currentMonthText, classes.bold, percent_type)}>{'Increase'}</div> : <div className={clsx(classes.currentMonthText, classes.bold, percent_type)}>{''}</div>
                                                }
                                            </div>
                                        </Col>
                                        <Col span={14}>
                                            <div className={clsx(classes.triAngleContent, classes.triAngleContentImage, classes.inCurrentTriAngleContentImage)}>
                                                <div className={classes.bgFull} style={{ backgroundImage: `url(${currentMonth})` }}></div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                                <div className={clsx(classes.triAngleContent, classes.triAngleContentAnimation)}>
                                    <div className={clsx(classes.triAngleContentText, classes.bold)}>{`Current Month ${sTitle} Total`}</div>
                                    <div className={clsx(classes.triAngleContentAmount, classes.bold)}>₹ {currencyFormatInt(currentMonthTotal)}</div>
                                </div>
                            </div>
                            <div className={clsx(classes.lastMonth, classes.lastMonthBorder)}>
                                <div className={clsx(classes.triAngleContent, classes.triAngleContentImage, classes.inLastTriAngleContentImage)}>
                                    <div className={classes.bgFull} style={{ backgroundImage: `url(${lastMonth})` }}></div>
                                </div>
                                <div className={clsx(classes.triAngleContent, classes.triAngleContentAnimation)}>
                                    <div className={clsx(classes.triAngleContentAmount, classes.bold)}>₹ {currencyFormatInt(lastMonthTotal)}</div>
                                    <div className={clsx(classes.triAngleContentText, classes.bold)}>{`Last Month ${sTitle} Total`}</div>
                                </div>
                            </div>
                        </>
                    }
                </div>
            </div>
        </div>
    );
}